import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
// import { useStore } from 'Store';
// import { ProgramModel } from '@24i/st-api-connector';
import DownloadItem from './DownloadItem';

// TODO: Use different offline logic than sdk-media-offline
const DownloadsList = ({
    downloads,
    isEditing,
    selectedIds,
    togglePause,
    setSelectedIds,
    deleteById
}) => {
    const toggleId = useCallback(
        (id) => (toggle) => {
            if (toggle) setSelectedIds([...selectedIds, id]);
            else {
                const delIndex = selectedIds.indexOf(id);
                if (delIndex >= 0) {
                    const newItems = [...selectedIds];
                    newItems.splice(delIndex, 1);
                    setSelectedIds(newItems);
                }
            }
        },
        [selectedIds]
    );

    // const { setPlayerData } = useStore();
    const onPressDownload = useCallback(async (item) => {
        console.log(item);
        // const download = await StreamStorageManager.getDownload(`${item.id}`);
        // if (download.state === DOWNLOAD_STATES.STATE_COMPLETED) {
        //     setPlayerData({
        //         item: new ProgramModel(JSON.parse(download.request.data).item.data),
        //         offline: true,
        //         streamUrl: download.playURL
        //             ? download.playURL.replace('file:///', 'file:///')
        //             : download.request.uri
        //     });
        // } else {
        //     togglePause(item.id);
        // }
    });

    return (
        <View>
            {downloads.map(
                (download) =>
                    download &&
                    download.id && (
                        <DownloadItem
                            key={`${download.id}_${isEditing}`}
                            title={download.title}
                            subTitle={download.subtitle}
                            progressText={download.progressText}
                            progress={
                                download && download.progressPercent
                                    ? download.progressPercent
                                    : undefined
                            }
                            isEditing={isEditing}
                            isSelected={selectedIds.includes(download.id)}
                            onCheckbox={toggleId(download.id)}
                            isPaused={download.paused}
                            togglePause={() => togglePause(download.id)}
                            deleteItem={deleteById(download.id)}
                            onPress={() => onPressDownload(download)}
                            item={download && download.item}
                        />
                    )
            )}
        </View>
    );
};

DownloadsList.propTypes = {
    downloads: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isEditing: PropTypes.bool.isRequired,
    selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    setSelectedIds: PropTypes.func.isRequired,
    deleteById: PropTypes.func.isRequired,
    togglePause: PropTypes.func.isRequired
};

export default DownloadsList;
